import React, { useState } from "react";
import Images from "../../../media/images";

const NewFormPayment = ({ handleSubmit, handleClick, setUploadProof = null, totalAmount = 0, dueAmount = 0, setPaidAmount = null }) => {


    const [payment, setPayment] = useState("1")

    const handleImgChange = (e) => {
        let reader = new FileReader();
        let baseURL = "";
        reader.readAsDataURL(e.target.files[0]);
        // on reader load somthing...
        return new Promise((resolve) => {
            reader.onload = () => {
                // Make a fileInfo Object
                // console.log("Called", reader);
                baseURL = reader.result;
                // baseURL = baseURL.slice(5,baseURL.length)
                // baseURL += "="
                // arr[index].image = baseURL;
                setUploadProof(baseURL)

                resolve(baseURL);
            };
        });
    }


    return (
        <div
            className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="exampleModalSumbit"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-modal="true"
            role="dialog"
        >
            <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
                <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div className="flex justify-end">
                        <svg
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="text-primary-blue h-8 w-8"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            role="img"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                            />
                        </svg>
                    </div>
                    <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
                        <h5
                            className="text-primary-red -mt-5 text-center text-2xl font-bold"
                            id="exampleModalXlLabel"
                        >
                            तपाईले Upload गर्नुभएको फाईल हाम्रो कर्मचारीहरुले हेर्दै हुनुहुन्छ ।
                        </h5>
                    </div>
                    <div className="modal-body font-Palanquin relative m-3 p-4">

                        <div className="m-auto text-center">

                            <button
                                onClick={handleSubmit(handleClick)}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                type="submit"
                                className="bg-primary-blue rounded-full my-3  m-auto p-2 font-bold text-white sm:text-xl">
                                Upload proof
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewFormPayment;
